<div class="modal">
  <div class="flex justify-end items-center">
    <button type="button" class="close-button" (click)="close()" aria-label="Close">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>
  </div>

  <div class="modal__content">
    <div>
      <div class="text-center">
        <h2 class="modal__content-title">
          {{ title }}
        </h2>
      </div>
      <div class="notification-body my-6" [innerHTML]="sanitizedBody"></div>
    </div>
  </div>
</div>
